import { cleartaxAxios, mainAxios } from '../../../http-common';

export interface IHsnData {
  chapter: string;
  description: string;
  hsnCode: string;
  rate: string;
  cess: string;
  rateRevision: string;
  effectiveDate: string;
}

export interface IHsnDataCollection {
  hsn: Record<string, Array<IHsnData>>;
  sac: Record<string, Array<IHsnData>>;
}

export interface IProductHsnCodes {
  link: string;
  name: string;
}

interface IAlgoliaHitsResultHsn {
  chapter_name: string;
  _highlightResult: {
    product_description: {
      value: string;
    };
  };
  product_hsn_code: string;
  product_rate: string;
  product_cess: string;
  product_rate_revision: string;
  product_effective_date: string;
  type: string;
}
export class HsnDataService {
  static async getHsnCodesAlgolia(text: string): Promise<IHsnDataCollection> {
    const data = {
      requests: [
        {
          indexName: 'HSN_SAC_2021',
          params: `query=${text}&optionalWords=${text}&highlightPreTag=<strong>&highlightPostTag=</strong>&typoTolerance=false`,
        },
      ],
    };
    try {
      const hsnData = await cleartaxAxios.post(
        '/f/content_search/algolia/algolia-search/',
        data
      );
      const testData: IHsnDataCollection = { hsn: {}, sac: {} };
      hsnData.data.results[0].hits.forEach((ele: IAlgoliaHitsResultHsn) => {
        const obj: IHsnData = {
          chapter: ele.chapter_name,
          description:
            ele &&
            ele._highlightResult &&
            ele._highlightResult.product_description &&
            ele._highlightResult.product_description.value,
          hsnCode: ele.product_hsn_code,
          rate: ele.product_rate ? ele.product_rate : '-',
          cess: ele.product_cess ? ele.product_cess : '-',
          rateRevision: ele.product_rate_revision
            ? ele.product_rate_revision
            : '-',
          effectiveDate: ele.product_effective_date
            ? ele.product_effective_date
            : '-',
        };

        const chapterKey = ele.chapter_name as keyof IHsnData;
        if (ele.type == 'HSN') {
          if (!testData.hsn || !testData.hsn[chapterKey]) {
            testData.hsn[chapterKey] = [obj];
          } else {
            testData.hsn[chapterKey]?.push(obj);
          }
        } else {
          if (!testData.sac[ele.chapter_name]) {
            testData.sac[ele.chapter_name] = [obj];
          } else {
            testData.sac[ele.chapter_name]?.push(obj);
          }
        }
      });

      return testData;
    } catch (e) {
      return { hsn: {}, sac: {} };
    }
  }

  static async productWiseHsnCode(): Promise<Array<IProductHsnCodes>> {
    try {
      const response = await mainAxios.get(
        'https://script.googleusercontent.com/macros/echo?user_content_key=h3qB2MkmYk--FJganpfqCf0DR6MCxsUpaxnRqXBE6rq_D3B3N9HtZMHNjcVaSah1g11y-G0nSE3zy6klPsV345yeO2Wb7bxXOJmA1Yb3SEsKFZqtv3DaNYcMrmhZHmUMWojr9NvTBuBLhyHCd5hHayRnfenleVg2S5gntkw20DQJrDfxUHk7iEhSw4T5wrp4MgMdPsOrDG4IQQmyJfOCLX-TcLd78P_heu3CHl8wHxQcVluZiDL7m5BN_k9x8zqSap6NzR_o1YelRHxRHyf5Qg&lib=MRdmINvBrww-1MSx0MdmYmWPmECfWQYhC'
      );
      return response.data;
    } catch (e) {
      return [];
    }
  }
}
